<template>
    <div class="sembonus-join">
        <Box padding="none" radius="s">
            <div class="sembonus-join-inner">
                <div class="sembonus-join-ilustration">
                    <Illustration
                        :data="{ type: 'Join4', primary: 'black', accent: 'summer' }"
                        :text="joinMessage" />
                </div>

                <div class="sembonus-join-content">
                    <Info />

                    <div v-if="!isAuthorized" class="sembonus-join-actions">
                        <Actions />
                    </div>
                    <div v-else-if="isEligible" class="sembonus-join-actions">
                        <SignUp />
                    </div>
                </div>
            </div>
        </Box>
    </div>
</template>

<script lang="ts">
    import { t } from '@shared/helpers/translation';
    import { defineComponent, computed, onMounted } from 'vue';
    import { useScreenSize } from '@shared/helpers/viewport';
    import { logStatsigCheckoutSembonusView } from '@/tracking/statsig/checkout.functions';
    import { SembonusView } from '@/tracking/statsig/types';
    import { useStore } from '@/store';
    import { Cart } from '@/api/Cart/cart.interfaces';
    import Box from '@ui/components/Box/Box.vue';
    import Illustration from '@ui/components/Illustration/Illustration.vue';
    import Actions from './Actions/Actions.vue';
    import SignUp from './SignUp/SignUp.vue';
    import Info from '../Shared/Info/Info.vue';
    import { trackClarity } from '@/tracking/clarity';
    import { ClarityEvent } from '@/tracking/clarity/types';

    export default defineComponent({
        name: 'Join',
        methods: { t },
        props: {
            isAuthorized: { type: Boolean, required: true },
            isEligible: { type: Boolean, required: true },
        },
        components: {
            Actions,
            SignUp,
            Illustration,
            Box,
            Info,
        },
        setup(props) {
            const { isTablet, isDesktop } = useScreenSize();

            const store = useStore();
            const cart = computed<Cart>(() => store.state.cart.data);

            const joinMessage = computed(() => {
                const result = [] as string[];
                const lines = [1, 2, 3];

                lines.forEach((line) => {
                    result.push(t({ key: `sembonus.join_message.line${line}` }));
                });

                return result;
            });

            onMounted(() => initTracking());

            function initTracking() {
                if (!props.isAuthorized) {
                    logStatsigCheckoutSembonusView(SembonusView.Unauthorized, cart.value);
                    trackClarity(ClarityEvent.CHECKOUT_SEMBONUS_UNAUTHORIZED);
                } else if (props.isEligible) {
                    logStatsigCheckoutSembonusView(SembonusView.Join, cart.value);
                    trackClarity(ClarityEvent.CHECKOUT_SEMBONUS_AUTHORIZED);
                } else {
                    logStatsigCheckoutSembonusView(SembonusView.NotEligible, cart.value);
                    trackClarity(ClarityEvent.CHECKOUT_SEMBONUS_NOT_ELIGIBLE);
                }
            }

            return {
                isTablet,
                isDesktop,
                joinMessage,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'Join';
</style>
